import {
  Component,
  Output,
  EventEmitter,
  Input,
  ElementRef,
  Renderer2,
  OnInit,
  AfterViewInit,
  OnDestroy
} from '@angular/core';

import { ModalDismissReasons } from './modal-dismiss-reasons';

@Component({
    selector: 'ngb-modal-window',
    host: {
        '[class]': '"modal fade show" + (windowClass ? " " + windowClass : "")',
        'role': 'dialog',
        'tabindex': '-1',
        'style': 'display: block;',
        '(keydown.esc)': 'escKey($event)',
        '(click)': 'backdropClick($event)'
    },
    template: `
    <div [class]="'modal-dialog' + (size ? ' modal-' + size : '')" role="document">
        <div class="modal-content"><ng-content></ng-content></div>
    </div>
    `,
    standalone: false
})
export class NgbModalWindow implements OnInit,
  AfterViewInit, OnDestroy {
  private _elWithFocus: Element;  // element that is focused prior to modal opening

  @Input() backdrop: boolean | string = true;
  @Input() keyboard = true;
  @Input() size: string;
  @Input() windowClass: string;

  @Output('dismiss') dismissEvent = new EventEmitter();

  constructor(private _elRef: ElementRef, private _renderer: Renderer2) { }

  backdropClick($event): void {
    if (this.backdrop === true && this._elRef.nativeElement === $event.target) {
      this.dismiss(ModalDismissReasons.BACKDROP_CLICK);
    }
  }

  escKey($event): void {
    if (this.keyboard && !$event.defaultPrevented) {
      this.dismiss(ModalDismissReasons.ESC);
    }
  }

  dismiss(reason): void { this.dismissEvent.emit(reason); }
  show(backdropNativeEl) {
    this._renderer.addClass(document.body, 'modal-open');
    this._renderer.addClass(backdropNativeEl, 'modal-backdrop');
    this._renderer.addClass(backdropNativeEl, 'show');
    this._renderer.removeClass(backdropNativeEl, 'hide');
    this._renderer.setStyle(this._elRef.nativeElement, 'display', 'block');
    this._elRef.nativeElement.focus();
  }
  hide(backdropNativeEl) {
    this._renderer.removeClass(document.body, 'modal-open');
    this._renderer.removeClass(backdropNativeEl, 'modal-backdrop');
    this._renderer.removeClass(backdropNativeEl, 'show');
    this._renderer.addClass(backdropNativeEl, 'hide');
    this._renderer.setStyle(this._elRef.nativeElement, 'display', 'none');

  }
  ngOnInit() {
    this._elWithFocus = document.activeElement;
    this._renderer.addClass(document.body, 'modal-open');
  }

  ngAfterViewInit() {
    if (!this._elRef.nativeElement.contains(document.activeElement)) {
      this._elRef.nativeElement['focus'].apply(this._elRef.nativeElement, []);
    }
  }

  ngOnDestroy() {
    const body = document.body;
    const elWithFocus = this._elWithFocus;

    let elementToFocus;
    if (elWithFocus && elWithFocus['focus'] && body.contains(elWithFocus)) {
      elementToFocus = elWithFocus;
    } else {
      elementToFocus = body;
    }
    elementToFocus['focus'].apply(elementToFocus, []);

    this._elWithFocus = null;
    this._renderer.removeClass(body, 'modal-open');
    this._renderer.removeAttribute(body, 'class');
  }
}
